export function monthAbbrev(monthNum) {
    const monthAbbrevs = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    return monthAbbrevs[monthNum] || "";
}